import { instance } from "./";
import notify from 'devextreme/ui/notify';

export const getResourceList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/site"
  }).catch(() => {
    notify({
      closeOnClick: true,
      closeOnOutsideClick: true,
      message: 'Не удалось загрузить данные'
    }, 'error');
  });
  return response;
};

export const getResource = id => {
  const response = instance({
    method: "get",
    url: `/work/api/site/${id}`
  });
  return response;
};

export const createResource = data => {
  const response = instance({
    method: "post",
    url: `/work/api/site/`,
    data
  });
  return response;
};

export const deleteResource = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/site/${id}`
  });
  return response;
};

export const updateResource = (id, main) => {
  const data = { main: { ...main, } };

  const response = instance({
    method: "put",
    url: `/work/api/site/${id}`,
    data
  });
  return response;
};

export const getAccessTypes = () => {
  const response = instance({
    method: "get",
    url: "/work/api/dict/site-access"
  });
  return response;
};

export const getOrganizationsList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/organization"
  });
  return response;
};

export const getDepartmentsList = id => {
  const response = instance({
    method: "get",
    url: `/work/api/organization/${id}/department`
  });
  return response;
};

export default {
  getResourceList,
  getResource,
  createResource,
  deleteResource,
  updateResource,
  getOrganizationsList,
  getDepartmentsList,
  getAccessTypes
}
